var React = require('react');

function LocationPin (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"none","height":"24","width":"24","key":0}),React.createElement("path",{"d":"M12,2L12,2C8.13,2,5,5.13,5,9c0,1.74,0.5,3.37,1.41,4.84c0.95,1.54,2.2,2.86,3.16,4.4c0.47,0.75,0.81,1.45,1.17,2.26 C11,21.05,11.21,22,12,22h0c0.79,0,1-0.95,1.25-1.5c0.37-0.81,0.7-1.51,1.17-2.26c0.96-1.53,2.21-2.85,3.16-4.4 C18.5,12.37,19,10.74,19,9C19,5.13,15.87,2,12,2z M12,11.75c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5 S13.38,11.75,12,11.75z","key":1})]);
}

LocationPin.defaultProps = {"enableBackground":"new 0 0 24 24","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = LocationPin;

LocationPin.default = LocationPin;
